// extracted by mini-css-extract-plugin
module.exports = {"PasswordReset":"PasswordReset_PasswordReset__2ylAC","text":"PasswordReset_text__3oi2M","buttonContainer":"PasswordReset_buttonContainer__3p33d"};